var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shift-start-page page-content"},[_c('h2',[_vm._v("Inicio de turno")]),_vm._v(" "),_c('app-shift-form',{attrs:{"is-start":true,"is-other":_vm.isOther}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }